<template>
  <div>
    <!-- 查询 -->
    <div style="text-align:right">
      <el-form inline>
        <el-form-item :label="$t('time.timeQuery')">
          <el-date-picker
            v-model="daterange"
            type="daterange"
            :picker-options="datePickerOptions"
            :range-separator="$t('time.to')"
            :start-placeholder="$t('time.startDate')"
            :end-placeholder="$t('time.endDate')"
            :size="size"
            style="width:265px">
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('vehicle.carNo') + ':'" style="margin-left:3px">
          <el-input v-model="inputCarno" :placeholder="$t('maintenance.pleaseEnterTheLicensePlateNumber')" :size="size" clearable style="width:125px"></el-input>
        </el-form-item>
        <el-form-item :label="$t('maintenance.state') + ':'" style="margin-left:3px">
          <el-select v-model="state" placeholder="" :size="size" style="width:85px" @change="typeChange">
            <el-option :label="$t('public.all')" value="-1"></el-option>
            <el-option :label="$t('maintenance.processed')" value="1"></el-option>
            <el-option :label="$t('maintenance.pending')" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('maintenance.maintananceType') + ':'" style="margin-left:3px">
          <el-select v-model="maintenanceType" placeholder="" :size="size" style="width:130px" @change="typeChange">
            <el-option 
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item >
          <el-button 
            :size="size"
            type="primary" 
            style="margin-left:10px"
            @click="handleQuery"
          >{{ $t("public.query")}}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <div class="page_container">
      <el-table :data="dataList" border :size="size" v-loading="loading">
        <el-table-column :label="$t('maintenance.order')" align="center" type="index" width="75"></el-table-column>
        <el-table-column :label="$t('maintenance.state')" align="center" min-width="">
          <template slot-scope="scope">
            <div :style="{color: scope.row.state == '0' ? 'red' : 'green'}">
              {{stateChange(scope.row.state)}}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('maintenance.carNo')" align="center" prop="carNo" min-width=""></el-table-column>
        <el-table-column :label="tableLable" align="center" prop="maintananceData" min-width=""></el-table-column>
        <el-table-column :label="$t('maintenance.handlingOpinions')" align="center" prop="opinion" min-width=""></el-table-column>
        <el-table-column :label="$t('maintenance.processor')" align="center" prop="processor" min-width=""></el-table-column>
        <el-table-column :label="$t('maintenance.processingTime')" align="center" prop="processingTime" min-width=""></el-table-column>
      </el-table>
    </div>
    <kl-pagination  style="padding-top:6px"
      :currentPage="currentPage" 
      :pageSize="PageSize" 
      :total="total" 
      @current-change="currentChange"
      @size-change="sizeChange"
    ></kl-pagination>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data(){
    return{
      PageSize:10,
      currentPage:1,
      loading:false,
      total:0,
      datePickerOptions: {
        disabledDate(date) {
            return date > new Date(new Date().getTime() -  24 * 60 * 60 * 1000)
        }
      },
      dataList:[],
      maintenanceType:"1",
      state:"-1",
      inputCarno:"",
      daterange:[],
      options: [
        {
          value: '1',
          label: this.$t("maintenance.driverQualification")
        }, 
        {
          value: '2',
          label: this.$t("maintenance.NJ")
        }, 
        {
          value: '3',
          label: this.$t("maintenance.BX")
        }, 
        {
          value: '4',
          label: this.$t("maintenance.BY") + '(' + this.$t("runState.km") + ")"
        }, 
        {
          value: '5',
          label: this.$t("maintenance.ZQBY")
        }, 
        // {
        //   value: '7',
        //   label: this.$t("maintenance.NextCheckTime_Year")
        // }, 
        // {
        //   value: '8',
        //   label: this.$t("maintenance.NextCheckTime_Quarter")
        // }
      ],
    }
  },
  props:{
    size:{
      type:String,
    }
  },
  computed:{
    tableLable() {
      var item = this.options.filter((element) =>{
        return this.maintenanceType == element.value;
      })
      return item[0].label;
    },
    ...mapState({
      operator: (state) => state.user.operator,
    }),
  },
  watch:{
  },
  methods:{
    sizeChange(val){
      this.PageSize = val;
      this.currentPage = 1;
      this.getList();
    },
    currentChange(page){
      this.currentPage = page;
      this.getList();
    },
    stateChange(index){
      if(index == "0") return this.$t("maintenance.pending");
      if(index == "1") return this.$t("maintenance.processed");
    },
    handleQuery(){
      // console.log(this.moment(this.daterange[0]).format("YYYY-MM-DD"));
      // console.log(this.daterange);
      this.daterange = this.daterange == null ? [] : this.daterange;
      this.getList();
    },
    typeChange(){
      // if(this.dataList.length == 0) return;
      // console.log("变更，刷新")
      this.getList();
    },
    getList(){
      this.loading = true;
      this.$api.maintainRecordInfo({
        CompanyID:this.operator.CompanyId,//26075,
        beginDate: (this.daterange.length == 0) ? "" : this.moment(this.daterange[0]).format("YYYY-MM-DD"),
        endDate: (this.daterange.length == 0) ? "" : this.moment(this.daterange[1]).format("YYYY-MM-DD"),
        vehicle: this.inputCarno,
        state: this.state,
        maintenanceType: this.maintenanceType,
        OperatorID: this.$store.getters.operator.OperatorId,
        PageNo:this.currentPage,
        PageSize: this.PageSize,
      })
      .then((res)=>{
        if(res.code == 200){
          this.total = res.count;
          this.dataList = res.data;
          this.loading = false;
        }
      })
      .catch((e)=>{
        this.loading = false;
      })
    },
  },
  mounted(){
    this.getList();
    // this.daterange = [new Date(new Date().getTime() - 2*24*60*60*1000),new Date(new Date().getTime() - 24*60*60*1000)]
  },
}
</script>
<style lang="scss" scoped>
 
</style>